import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/models';
import Cookies from 'js-cookie';
import cs from './index.module.scss';

export interface DropDownMenuItem {
  url: string;
  icon?: string;
  title: string;
  subTitle?: string;
  slot?: any;
}

interface Props extends React.ComponentProps<any> {
  data?: DropDownMenuItem[];
  onClick?: () => void;
}

const DropDownMenu: React.FC<Props> = ({ data }) => {
  const { push } = useHistory();
  const { account, otc, otcConsumer } = useStore();

  const { fetchGetReceipt } = otcConsumer;

  const { fetchOtcInfo, setToAuthModalVisible, toAuthModalVisible, fetchSupportCoin } = otc;
  const { userInfo } = account;
  const { idNoStatus } = userInfo;
  const handleClick = async item => {
    const { url, onClick, isAuth } = item;
    if (isAuth && idNoStatus !== 1) {
      setToAuthModalVisible(true);
    } else if (onClick) {
      onClick();
    } else if (/^[(http)|(https)]/.test(url)) {
      window.location.href = url;
    } else {
      if (url === '/account/otc/index') {
        fetchSupportCoin();
        const token = Cookies.get('token');
        if (token) {
          await fetchOtcInfo();
          await fetchGetReceipt();
        }
      }
      push(url);
    }
  };

  return (
    <div className={cs.container}>
      {data?.map((item: any, index: number) => {
        const { title: menuTitle, subTitle, slot } = item;

        return (
          <a key={index} className={cs.dropdownItem} onClick={() => handleClick(item)}>
            {item.titleIcon && <div className={cs.icon}>{item.titleIcon}</div>}
            <div className={cs.label}>
              {menuTitle && <b>{menuTitle}</b>}
              {subTitle && <div>{subTitle}</div>}
              {slot && <div>{slot}</div>}
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default observer(DropDownMenu);
